<template>
  <div class="col-12 col-md-12 col-lg-6">
    <div class="tit text-center">
      <p>Por favor, selecione que tipo de empresa é a(o) <strong>{{razaoSocial}}</strong>:</p>
    </div>
    <div class="row justify-content-center">
      <div class="col-12 col-md-10 col-lg-8 col-xl-7">
        <form @submit="onSubmit">
          <ul class="list-group">
            <li class="list-group-item">
              <div class="form-check">
                <div class="checkContainer">
                  <input class="form-check-input" v-model.number="tipoEmpresa" type="radio" name="TipoEmpresa" id="mei" value="1" required>
                  <span class="checkmark"></span>
                  <label class="form-check-label" for="mei">MEI</label>
                </div>
              </div>
            </li>
            <li class="list-group-item">
              <div class="form-check">
                <div class="checkContainer">
                  <input class="form-check-input" v-model.number="tipoEmpresa" type="radio" name="TipoEmpresa" id="me" value="2" required>
                  <span class="checkmark"></span>
                  <label class="form-check-label" for="me">ME</label>
                </div>
              </div>
            </li>
            <li class="list-group-item">
              <div class="form-check">
                <div class="checkContainer">
                  <input class="form-check-input" v-model.number="tipoEmpresa" type="radio" name="TipoEmpresa" id="epp" value="3" required>
                  <span class="checkmark"></span>
                  <label class="form-check-label" for="epp">EPP</label>
                </div>
              </div>
            </li>
            <li class="list-group-item">
              <div class="form-check">
                <div class="checkContainer">
                  <input class="form-check-input" v-model.number="tipoEmpresa" type="radio" name="TipoEmpresa" id="eireli" value="4" required>
                  <span class="checkmark"></span>
                  <label class="form-check-label" for="eireli">EIRELI</label>
                </div>
              </div>
            </li>
            <li class="list-group-item">
              <div class="form-check">
                <div class="checkContainer">
                  <input class="form-check-input" v-model.number="tipoEmpresa" type="radio" name="TipoEmpresa" id="ltda" value="5" required>
                  <span class="checkmark"></span>
                  <label class="form-check-label" for="ltda">LTDA</label>
                </div>
              </div>
            </li>
            <li class="list-group-item">
              <div class="form-check">
                <div class="checkContainer">
                  <input class="form-check-input" v-model.number="tipoEmpresa" type="radio" name="TipoEmpresa" id="sa" value="6" required>
                  <span class="checkmark"></span>
                  <label class="form-check-label" for="sa">S/A</label>
                </div>
              </div>
            </li>
            <li class="list-group-item">
              <div class="form-check">
                <div class="checkContainer">
                  <input class="form-check-input" v-model.number="tipoEmpresa" type="radio" name="TipoEmpresa" id="outro" value="7" required>
                  <span class="checkmark"></span>
                  <label class="form-check-label" for="outro">Outro</label>
                </div>
              </div>
            </li>
          </ul>
          <div class="form-group text-left" v-if="ehOutro">
            <label for="dataFundacao">Infome o tipo de empersa</label>
            <input type="text" class="form-control form-control-lg" v-model="tipoEmpresaOutro" required>
          </div>
          <div class="text-center fixedOptions">
            <button class="btn btn-lg btn-primary">Próximo <img src="../../assets/images/angle-right.svg"></button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
const TIPO_EMPRESA_OUTRO = 7

export default {
  data() {
    return {
      razaoSocial: this.solicitacao.Empresa.RazaoSocial,
      tipoEmpresa: this.solicitacao.Empresa.TipoEmpresa,
      tipoEmpresaOutro: this.solicitacao.Empresa.TipoEmpresaOutro
    }
  },
  props: {
    solicitacao: {required: true, type: Object}
  },
  computed: {
    ehOutro() {return this.tipoEmpresa == TIPO_EMPRESA_OUTRO}
  },
  methods: {
    onSubmit(e) {
      e.preventDefault()

      const tipoEmpresa = this.tipoEmpresa
      let newData = {Empresa: {TipoEmpresa: tipoEmpresa}}
      if(tipoEmpresa == TIPO_EMPRESA_OUTRO) {
        newData.Empresa.TipoEmpresaOutro = this.tipoEmpresaOutro
      } else {
        newData.Empresa.TipoEmpresaOutro = null
      }
      this.$emit('on-submit', newData)
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/AdditionalInformationPeerToPeer/CompanyTypeStep.vue